<template>
  <div class="container">
    <div class="leftBottom">
      <div class="time">{{time}}</div>
    </div>
    <div class="rightBottom">
      <div class="item" @click="handleClick('0')">
        <img src="../../assets/share.png" alt />
        <span>分享</span>
      </div>
      <div class="item" @click="handleClick('1')">
        <img src="../../assets/print.png" alt />
        <span>打印</span>
      </div>
      <div class="item" @click="handleClick('2')">
        <img src="../../assets/download.png" alt />
        <span>下载</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventEndBottom",
  props: {
    time: {
      type: String,
    },
  },
  methods: {
    handleClick($event) {
      this.$emit("click", $event);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 47px;
  display: flex;
  align-items: center;
  .leftBottom {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    .time {
      font-size: 14px;
      color: #99a9ba;
    }
  }
  .rightBottom {
    width: 172px;
    height: 100%;
    display: flex;
    align-items: center;
    .item {
      margin-right: 15px;
      cursor: pointer;
      img {
        vertical-align: middle;
        margin-right: 6px;
      }
      span {
        font-size: 10px;
        color: #969aa5;
        letter-spacing: 1px;
      }
    }
    .item:last-child {
      margin-right: 0;
    }
  }
}
</style>